import { FC } from 'react'
import { dateToFormat } from '@/root/shared-helpers'
import { dateFormats } from '@/root/shared-consts'
import { ChevronDownIcon } from '@/root/ui/shared/icons/ChevronDownIcon'
import ArrowLong from '@/icons/ArrowLong'

interface RouteInfoProps {
  arrivalPort: string
  departurePort: string
}

const RouteInfo: FC<RouteInfoProps> = ({ arrivalPort, departurePort }) => {
  return (
    <div className="flex items-center justify-center gap-3 border-b py-4 text-xl leading-none uppercase md:justify-start md:gap-3">
      <p className="text-center">{departurePort}</p>
      <ArrowLong width={18} height={18} color="black" />
      <p>{arrivalPort}</p>
    </div>
  )
}

export default RouteInfo
